import { FC, ReactNode } from 'react';

interface LLButtonProps {
  testId?: string;
  automationId?: string;
  type?: 'button' | 'submit' | 'reset';
  variation?: 'primary' | 'secondary' | 'tertiary';
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children?: ReactNode;
  customClass?: string;
}

const LLButton: FC<
  React.ButtonHTMLAttributes<HTMLButtonElement> & LLButtonProps
> = ({
  automationId,
  testId,
  id,
  type = 'button',
  disabled,
  variation = 'primary',
  onClick,
  children,
  customClass,
}) => {
  return (
    <button
      id={id}
      className={`btn btn-${variation} ${disabled === true ? 'disabled' : ''} ${customClass ? customClass : ''}`}
      automation-id={automationId}
      data-testid={testId}
      disabled={disabled}
      type={type}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default LLButton;
